import { Star } from '@otp/icons';
import {
  ActionsColumn,
  CustomHeadLabelRenderOptions,
  DataTableMeta,
} from '@otp/ui';
import { TFunction } from 'i18next';
import React from 'react';

import { StoreModel, UserLevel } from 'src/graphql/generated/graphql';

import { RestaurantAddress, RestaurantStatus } from './columns';

const storeUsersCountByLevelRender = (value?: number | string) => {
  return value || 0;
};

export const getTableConfig = (
  restaurants: Partial<StoreModel>[],
  { t }: { t: TFunction },
) => [
  {
    name: 'isNeedAttention',
    label: t('manage-restaurants.store-status'),
    options: {
      sort: true,
      customBodyRender: (value: boolean) => {
        return <RestaurantStatus isNeedAttention={value} />;
      },
    },
  },
  {
    name: 'name',
    label: t('manage-restaurants.store-name'),
    options: {
      sort: true,
      customBodyRender: (value: any, column: DataTableMeta) => {
        const rowData = restaurants[column.rowIndex];
        return <RestaurantAddress restaurant={rowData} />;
      },
    },
  },
  {
    name: 'nationalStoreNumber',
    label: t('manage-restaurants.store-number'),
    options: {
      sort: false,
    },
  },
  {
    name: 'storeUsersCountByLevel.otp-3',
    label: t(`common.otp-levels.${UserLevel.Otp3}`),
    options: {
      sort: false,
      customBodyRender: storeUsersCountByLevelRender,
    },
  },
  {
    name: 'storeUsersCountByLevel.otp-2',
    label: t(`common.otp-levels.${UserLevel.Otp2}`),
    options: {
      sort: false,
      customBodyRender: storeUsersCountByLevelRender,
    },
  },
  {
    name: 'storeUsersCountByLevel.otp-1',
    label: t(`common.otp-levels.${UserLevel.Otp1}`),
    options: {
      sort: false,
      customBodyRender: storeUsersCountByLevelRender,
    },
  },
  {
    name: 'storeUsersCountByLevel.otp-0',
    label: t(`common.otp-levels.${UserLevel.Otp0}`),
    options: {
      sort: false,
      customBodyRender: storeUsersCountByLevelRender,
    },
  },
  {
    name: 'primaryOTPsCount',
    label: t('manage-restaurants.primary-otps'),
    options: {
      customHeadLabelRender: (options: CustomHeadLabelRenderOptions) => {
        return (
          <div className="flex items-center">
            <Star className="inline mr-1" /> {options.label}
          </div>
        );
      },
      sort: false,
    },
  },
  {
    name: 'otpsCount',
    label: t('manage-restaurants.assigned-otps'),
    options: {
      sort: true,
      customBodyRender: (_: any, column: DataTableMeta) => {
        const rowData = restaurants[column.rowIndex];
        const storeUsersCountByLevel = rowData.storeUsersCountByLevel as Record<
          string,
          number
        >;
        if (!storeUsersCountByLevel) {
          return 0;
        }

        const fitleredValue = Object.keys(storeUsersCountByLevel)
          .filter((key) => key.includes('otp'))
          .reduce(
            (obj, key) => {
              obj[key] = storeUsersCountByLevel[key];
              return obj;
            },
            {} as Record<string, number>,
          );

        return Object.values(fitleredValue).reduce(
          (sum, value) => sum + value,
          0,
        );
      },
    },
  },
  {
    name: 'actions',
    label: 'Actions',
    options: {
      customBodyRender: () => <ActionsColumn />,
      sort: false,
    },
  },
];
